// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { configureBudgetStyles } from "@insite/content-library/Widgets/Budget/ConfigureBudget";
import { xButtonSharedStyles } from "@werner/App/SharedStyle/Common/ButtonsSharedStyles";
import { mergeWithCss, xScreen } from "@werner/XDL/Utilities";
import { css } from "styled-components";

configureBudgetStyles.budgetYearSelectorStyles = {
    wrapper: {
        css: css`
            display: flex;
            margin: 0 30px 15px 0;
            min-width: 200px;
        `,
    },
};

configureBudgetStyles.cancelButton = {
    variant: "secondary",
    css: css`
        ${xScreen("lte", 500)} {
            width: 100%;
        }
    `,
};
configureBudgetStyles.saveButton = {
    ...configureBudgetStyles.saveButton,
    css: css`
        ${configureBudgetStyles.saveButton?.css}
        margin: 0;
        ${xScreen("lte", 500)} {
            width: 100%;
        }
    `,
};

configureBudgetStyles.removeIcon = {
    ...xButtonSharedStyles.removeIcon,
};

configureBudgetStyles.budgetYearEndDatePicker = {
    cssOverrides: {
        formField: css`
            width: auto;
            margin-right: 35px;
            margin-top: 28px;
            ${xScreen("lte", "sm")} {
                margin-top: 15px;
            }
        `,
    },
    labelProps: {
        css: css`
            margin-bottom: 3px;
        `,
    },
};

configureBudgetStyles.buttonsGridItem = {
    ...configureBudgetStyles.buttonsGridItem,
    css: css`
        ${configureBudgetStyles.buttonsGridItem?.css}
        gap: 10px;
        justify-content: flex-end;
        ${xScreen("lte", "sm")} {
            justify-content: flex-start;
            div[class^="HiddenStyle"] {
                display: flex;
                gap: 10px;
                width: 100%;
            }
        }
        ${xScreen("lte", 500)} {
            flex-direction: column-reverse;
        }
        ${xScreen("lte", 500)} {
            div[class^="HiddenStyle"] {
                flex-direction: column-reverse;
            }
        }
    `,
};
